import { render } from "./BigWhiteComponent.vue?vue&type=template&id=2f83e2f6&scoped=true"
import script from "./BigWhiteComponent.vue?vue&type=script&lang=js"
export * from "./BigWhiteComponent.vue?vue&type=script&lang=js"

import "./BigWhiteComponent.vue?vue&type=style&index=0&id=2f83e2f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f83e2f6"]])

export default __exports__